export function getTeleId(urlString: string) {
  try {
    const params = new URLSearchParams(urlString);
    const userEncoded = params.get("user");
    const userDecoded = decodeURIComponent(userEncoded || "");
    const userObject = JSON.parse(userDecoded);
    const userId = userObject.id;
    return userId.toString();
  } catch (error) {
    console.error("Token validation failed:", error);
    throw error;
  }
}
